import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-po-finish-prod-comp-list-accs',
  templateUrl: './po-finish-prod-comp-list-accs.component.html',
  styleUrls: ['./po-finish-prod-comp-list-accs.component.css']
})
export class PoFinishProdCompListAccsComponent implements OnInit {
    p2PoFinishKeyno;

    public selectedBgAccumulationSelection: string = 'A';

    public setting?: Setting;

    public itemsListComponents: Item[] = [];

    public finishing = false;

    public aborting = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoFinishKeyno = this.stateService.getStateParams()['p2_pofinish_keyno'];
    }

    private async loadSetting() {
        if (!!this.p2PoFinishKeyno) {
            this.setting = (await this.datatask.Post(211, { p2_pofinish_keyno: this.p2PoFinishKeyno }))[0];
        }
    }

    private async loadComponents() {
        if (!!this.p2PoFinishKeyno && !!this.selectedBgAccumulationSelection) {
            this.itemsListComponents = await this.datatask.Post(183, {
                p2_pofinish_keyno: this.p2PoFinishKeyno,
                selector: this.selectedBgAccumulationSelection
            });
        }
    }

    public async finishChanges() {
        if (!!this.p2PoFinishKeyno && !!this.stateService.getCurrentName()) {
            try {
                this.finishing = true;

                const response = (await this.datatask.Post(197, {
                    finishfromkey: 'p2_pofinish_keyno',
                    keyvalue: this.p2PoFinishKeyno,
                    from_webpagename: this.stateService.getCurrentName(),
                    from_parms: this.p2PoFinishKeyno
                }))[0];

                this.stateService.go(response?.webpagename, response?.webpage_parms);
            } finally {
                this.finishing = false;
            }
        }
    }

    public async abortTask() {
        if (!!this.p2PoFinishKeyno) {
            try {
                this.aborting = true;

                const response = (await this.datatask.Post(212, { p2_pofinish_keyno: this.p2PoFinishKeyno }))[0];

                    this.stateService.go(response?.webpagename, response?.webpage_parms);
            } finally {
                this.aborting = false;
            }
        }
    }

    public onTabChanged() {
        this.loadComponents();
    }

    private async init() {
        this.loadSetting();
        this.loadComponents();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    readytofinish: string;
}
